import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  Model
} from '@eggplant/types'

const ORPHANED_ONLY = 'orphaned_only'

interface OrphanedQuery {
  [ORPHANED_ONLY]: boolean
  spaceId?: string
}

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: Model[]) => void
  children?: (response: Model[]) => ReactElement
  shortErrorMessage?: string
  params?: OrphanedQuery
}

const GetComposerModels = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children,
  params
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/models`

  const { requestParams } = useGetParamsWithSpaceId<OrphanedQuery | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetComposerModels
